
/* injects from baggage-loader */

import loadTypes from 'utils/loadTypes'
import groupBy from 'lodash/groupBy'
import moment from 'moment'
import {orderReducer} from 'redux/modules/orders'

export const DASHBOARD_PROJECTION = loadTypes('DASHBOARD_PROJECTION')
export const DASHBOARD_CURRENT_TOTAL = loadTypes('DASHBOARD_CURRENT_TOTAL')
export const DASHBOARD_PREVIOUS_TOTAL = loadTypes('DASHBOARD_PREVIOUS_TOTAL')
export const DASHBOARD_CURRENT_TOTAL_NEW = loadTypes(
  'DASHBOARD_CURRENT_TOTAL_NEW'
)
export const DASHBOARD_PREVIOUS_TOTAL_NEW = loadTypes(
  'DASHBOARD_PREVIOUS_TOTAL_NEW'
)
export const DASHBOARD_TABLE = loadTypes('DASHBOARD_TABLE')
export const DASHBOARD_TABLE_TOTAL = loadTypes('DASHBOARD_TABLE_TOTAL')
export const DASHBOARD_TRAFFIC = loadTypes('DASHBOARD_TRAFFIC')
export const DASHBOARD_LAST_ORDERS = loadTypes('DASHBOARD_LAST_ORDERS')

const formatDate = (date, format) => {
  return moment(date).format(format)
}

const initialState = {
  projection: null,
  total: {
    traffic: {
      currentMonth: 0,
      prevMonth: 0
    },
    orderCount: {
      currentMonth: 0,
      prevMonth: 0
    },
    ftdCount: {
      currentMonth: 0,
      prevMonth: 0
    },
    regCount: {
      currentMonth: 0,
      prevMonth: 0
    },
    orderValue: {
      currentMonth: 0,
      prevMonth: 0
    },
    CPAValue: {
      currentMonth: 0,
      prevMonth: 0
    },
    costValue: {
      currentMonth: 0,
      prevMonth: 0
    }
  },
  totalCurrentFetching: false,
  totalPreviousFetching: false,
  table: [],
  tableTotal: [],
  projectionFetching: false,
  byDays: null,
  byDaysFetching: false,
  maxSessionCount: 0,
  lastOrders: null,
  lastOrdersFetching: false
}

function processTotalValues(state, action, name) {
  console.log('processTotalValues')
  const result = action.response[0]
  const data = {
    traffic: result['session:count'],
    orderCount: result['order:count-non-direct-last-click'],
    ftdCount: result['order:ftdCount-non-direct-last-click'],
    regCount: result['order:regCount-non-direct-last-click'],
    orderValue: result['order:total'],
    costValue: result['cost:total']
  }

  return Object.keys(state.total).reduce((acc, key) => {
    acc[key] = {
      ...state.total[key],
      [name]: data[key]
    }
    return acc
  }, {})
}
function processTotalValuesNew(state, action, name) {
  const result = action.response[0]

  const data = {
    traffic: result['session:count'],
    orderCount: result['order:count-non-direct-last-click'],
    ftdCount: result['order:ftdCount-non-direct-last-click'],
    regCount: result['order:regCount-non-direct-last-click'],
    orderValue: result['order:total'],
    costValue: result['cost:total'],
    CPAValue: result['cost:total'] / result['order:total']
  }

  return Object.keys(state.total).reduce((acc, key) => {
    acc[key] = {
      ...state.total[key],
      [name]: data[key]
    }
    return acc
  }, {})
}

export default function dashboard(state = initialState, action) {
  switch (action.type) {
    case DASHBOARD_PROJECTION.REQUEST:
      return {
        ...state,
        projectionFetching: true
      }

    case DASHBOARD_PROJECTION.SUCCESS:
      const dataProject = action.response
      return {
        ...state,
        projectionFetching: false,
        projection: dataProject.reduce((acc, item) => {
          acc[formatDate(item.day, 'YYYY-MM-DD')] = {
            traffic: item['session:count'],
            orderCount: item['order:count-non-direct-last-click'],
            orderValue: item['order:total'],
            costValue: item['cost:total'],
            ftdCount: item['order:ftdCount-non-direct-last-click'],
            regCount: item['order:regCount-non-direct-last-click'],
          }
          return acc
        }, {})
      }

    case DASHBOARD_PROJECTION.FAILURE:
      return {
        ...state,
        projectionFetching: false
      }

    case DASHBOARD_CURRENT_TOTAL.REQUEST:
      return {
        ...state,
        totalCurrentFetching: true
      }

    case DASHBOARD_CURRENT_TOTAL.SUCCESS:
      return {
        ...state,
        total: processTotalValues(state, action, 'currentMonth')
      }

    case DASHBOARD_CURRENT_TOTAL.FAILURE:
      return {
        ...state,
        totalCurrentFetching: false
      }
    case DASHBOARD_CURRENT_TOTAL_NEW.REQUEST:
      return {
        ...state,
        totalCurrentFetching: true
      }

    case DASHBOARD_CURRENT_TOTAL_NEW.SUCCESS:
      return {
        ...state,
        total: processTotalValuesNew(state, action, 'currentMonth')
      }

    case DASHBOARD_CURRENT_TOTAL_NEW.FAILURE:
      return {
        ...state,
        totalCurrentFetching: false
      }

    case DASHBOARD_PREVIOUS_TOTAL.REQUEST:
      return {
        ...state,
        totalPreviousFetching: true
      }

    case DASHBOARD_PREVIOUS_TOTAL.SUCCESS:
      return {
        ...state,
        total: processTotalValues(state, action, 'prevMonth')
      }

    case DASHBOARD_PREVIOUS_TOTAL.FAILURE:
      return {
        ...state,
        totalPreviousFetching: false
      }
    case DASHBOARD_PREVIOUS_TOTAL_NEW.REQUEST:
      return {
        ...state,
        totalPreviousFetching: true
      }

    case DASHBOARD_PREVIOUS_TOTAL_NEW.SUCCESS:
      return {
        ...state,
        total: processTotalValuesNew(state, action, 'prevMonth')
      }

    case DASHBOARD_PREVIOUS_TOTAL_NEW.FAILURE:
      return {
        ...state,
        totalPreviousFetching: false
      }
    case DASHBOARD_TABLE_TOTAL.REQUEST:
      return {
        ...state,
        fetchDashboardDataNew: true
      }

    case DASHBOARD_TABLE_TOTAL.SUCCESS:
      const tableTotal = action.response
      return {
        ...state,
        fetchDashboardDataNew: false,
        tableTotal: tableTotal[0]
      }

    case DASHBOARD_TABLE_TOTAL.FAILURE:
      return {
        ...state,
        fetchDashboardDataNew: false
      }
    case DASHBOARD_TABLE.REQUEST:
      return {
        ...state,
        fetchDashboardDataNew: true
      }

    case DASHBOARD_TABLE.SUCCESS:
      const table = action.response
      const countDivvit = Object.keys(table).reduce(
        (old, key) => old + table[key]['order:count-divvit'],
        0
      )
      const count = Object.keys(table).reduce(
        (old, key) => old + table[key]['order:count'],
        0
      )
      const countLastClick = Object.keys(table).reduce(
        (old, key) => old + table[key]['order:count-last-click'],
        0
      )

      const nonDirectLastClick = Object.keys(table).reduce(
        (old, key) => old + table[key]['order:count-non-direct-last-click'],
        0
      )

      const nonDirectClicks = Object.keys(table).reduce(
        (old, key) => old + table[key]['order:count-non-direct-clicks'],
        0
      )

      const nonDirectTouch = Object.keys(table).reduce(
        (old, key) => old + table[key]['order:count-non-direct-touch'],
        0
      )

      const nonDirectLastTouch = Object.keys(table).reduce(
        (old, key) => old + table[key]['order:count-non-direct-last-touch'],
        0
      )
      const countConversionTouched = Object.keys(table).reduce(
        (old, key) => old + table[key]['order:count-every-session'],
        0
      )
      return {
        ...state,
        fetchDashboardDataNew: false,
        tableTotal: {
          'order:count-divvit': countDivvit,
          'order:count': count,
          'order:count-last-click': countLastClick,
          'order:count-every-session': countConversionTouched,
          'order:count-non-direct-last-click': nonDirectLastClick,
          'order:count-non-direct-clicks': nonDirectClicks,
          'order:count-non-direct-touch': nonDirectTouch,
          'order:count-non-direct-last-touch': nonDirectLastTouch
        },
        table: table
      }

    case DASHBOARD_TABLE.FAILURE:
      return {
        ...state,
        fetchDashboardDataNew: false
      }

    case DASHBOARD_TRAFFIC.REQUEST:
      return {
        ...state,
        byDaysFetching: true
      }

    case DASHBOARD_TRAFFIC.SUCCESS:
      const channelGroups = groupBy(action.response, 'dimensions.channelGroup')
      let maxSessionCount = 0
      const byDays = Object.keys(channelGroups).reduce((acc, channelGroup) => {
        acc[channelGroup] = channelGroups[channelGroup].reduce((acc, day) => {
          const trafficCount = day['session:count']
          acc[formatDate(day.day, 'YYYY-MM-DD')] = {
            trafficCount,
            orderCount: day['order:count']
          }

          maxSessionCount = Math.max(maxSessionCount, trafficCount || 0)
          return acc
        }, {})
        return acc
      }, {})

      return {
        ...state,
        byDaysFetching: false,
        byDays,
        maxSessionCount: Math.round(maxSessionCount * 1.1)
      }

    case DASHBOARD_TRAFFIC.FAILURE:
      return {
        ...state,
        byDaysFetching: false
      }

    case DASHBOARD_LAST_ORDERS.REQUEST:
      return {
        ...state,
        lastOrdersFetching: true
      }

    case DASHBOARD_LAST_ORDERS.SUCCESS:
      const orderByGroup = action.response
      const keys = Object.keys(orderByGroup).filter(
        key => orderByGroup[key].length
      )

      return {
        ...state,
        lastOrdersFetching: false,
        lastOrders: keys.reduce((acc, key) => {
          acc[key] = orderByGroup[key].map(item => {
            item.order.sessions = [item.session]
            return orderReducer(item.order)
          })
          return acc
        }, {})
      }

    case DASHBOARD_LAST_ORDERS.FAILURE:
      return {
        ...state,
        lastOrdersFetching: false
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/dashboard/index.js